import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EmitterService } from '../common/services/emitter.service';
import { CommonConstants } from '../common/utilities/commonConstants';
import { SharedService } from 'src/app/common/services/sharedService';
import { RouteContextProvider } from './../common/services/routeContextProvider.service';
import { environment } from '../../environments/environment';
import { SessionHandlerService } from 'src/app/common/services/sessionHandler.service';
export class Notifier {
  valueChanged: (data: string) => void = (d: string) => { };
}

@Component({
  selector: 'custom-header',
  templateUrl: './header.template.html',
  styleUrls: ['./header.style.scss']
})
export class HeaderComponent implements OnInit {
  public ismotorRevampMobileApp = false;
  public ShowProgressInfo = false;
  public ProgressStateInfo: Model.ProgressStateInfo[];
  public bflJourney: boolean = false;
  @Input() pageHeaderTxt: any;
  @Input() VehicleType: string = '';
  @Output() eventFunction = new EventEmitter<string>();
  @Input() showNeedHelp: boolean = false;
  @Input() stepNumber: string;
  @Input() circleStagePercentage: string;
  isMobile: any;
  notifyObj = new Notifier();
  @Input() notify = new Notifier();
  displayNeedHelpText: boolean = false;
  @Output() needHelpClickEvent = new EventEmitter<string>();
  public autoLease : any;
  public product: string = '';
  showBackArrow: boolean = true;
  sdfcUCF: any;

  constructor(
    private _emitterService: EmitterService,
    public sharedService: SharedService,
    private _routeContextProvider: RouteContextProvider,
    private sessionHandlerService: SessionHandlerService,
  ) {
  }
  ngOnInit() {
    this._emitterService.Get(CommonConstants.EmitterEventTypes.ProgressStateEvent).subscribe(
      (progressStateInfo: Model.ProgressStateInfo[]) => {
        this.ProgressStateInfo = progressStateInfo;
        console.log('app.component: ' + progressStateInfo);
        this.ShowProgressInfo = true;
      });
    // Mobile header hide
    // this._emitterService.Get(CommonConstants.EmitterEventTypes.MobileAppCheck).subscribe(
    // (Key: string) => {
    //     if (Key === '1' ||  this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.IsMobile ==='1') {
    //         this.ismotorRevampMobileApp = true;
    //     }
    // });
    if (this._routeContextProvider.GetQueryParams('isMobile') === '1') {
      this.ismotorRevampMobileApp = true;
    }
    this.bflJourney = environment['bflenvironment'];
    this.isMobile = this._routeContextProvider.GetQueryParams('isMobile');
    this.showNeedHelpText();
    this.notify.valueChanged = (d: string) => {
      this.notifyChild();
    };
    this.autoLease = this.sessionHandlerService.GetSession(CommonConstants.CookieKeys.autoLease)
    this.product = this.sessionHandlerService.GetSession(CommonConstants.CookieKeys.product);
    this.sdfcUCF = this.sessionHandlerService.GetSession(CommonConstants.CookieKeys.sfdcUCF)
    //Below behavior subject subscribed to check knowmoredrawer state
    this.sharedService.isKnowMoreDrawerOpen$.subscribe((isOpen) => {
      //below condition is addded as will get open drawer state in both autolease and non autolease
      if (this.autoLease === 'true' || this.sdfcUCF == 'true') {
        this.showBackArrow = isOpen ? true : false
      } else {
        this.showBackArrow == true
      }
    });
    //Below condition is addded for landing page back arrow handling
    if (this.autoLease === 'true' || this.sdfcUCF == 'true') {
      this.showNeedHelp = false
      this.showBackArrow = false;
    } else {
      this.showBackArrow = true;
    }
  }
  showNeedHelpText() {
    const isMobile = this.sessionHandlerService.GetSession('source');
    if (isMobile == 'mobileApp') {
      this.displayNeedHelpText = false;
    } else {
      this.displayNeedHelpText = true;
    }
  }

  goBack(event: any) {
    this.eventFunction.emit(event);
  }
  notifyChild(): void {
    this.showNeedHelp = true;
    this.notifyObj.valueChanged('callpopup');
  }
  cleverTapPayload() {
    this.needHelpClickEvent.emit();
  }
}